import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from '@base-ui/react/autocomplete';
import type { ComponentProps } from 'react';
import { getProductResultUrl, getSearchResultUrl } from '../../../lib';
import type { PrimaryResultItem, SearchResultItem } from '../../../search.types';
import { ProductResult } from './product-result';
import { SuggestionResult } from './suggestion-result';
type SearchResultLinkClickHandler = NonNullable<ComponentProps<typeof Autocomplete.Item>['onClick']>;
type SearchResultLinkProps = {
  onResult: (result: SearchResultItem) => void;
  query: string;
  result: PrimaryResultItem;
};
export function SearchResultLink(t0) {
  const $ = _c(17);
  const {
    onResult,
    query,
    result
  } = t0;
  const {
    item
  } = result;
  const isProduct = item.kind === "product";
  let t1;
  if ($[0] !== isProduct || $[1] !== item || $[2] !== query) {
    t1 = isProduct ? getProductResultUrl(item, query) : getSearchResultUrl(item, query);
    $[0] = isProduct;
    $[1] = item;
    $[2] = query;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const href = t1;
  let t2;
  if ($[4] !== onResult || $[5] !== result) {
    t2 = event => {
      const keepNativeNavigation = event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
      event.preventBaseUIHandler();
      if (keepNativeNavigation) {
        return;
      }
      event.preventDefault();
      onResult(result);
    };
    $[4] = onResult;
    $[5] = result;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleClick = t2;
  let t3;
  if ($[7] !== isProduct || $[8] !== item) {
    t3 = isProduct ? <ProductResult product={item} /> : <SuggestionResult item={item} />;
    $[7] = isProduct;
    $[8] = item;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== href || $[11] !== t3) {
    t4 = <a className="header-search__item" href={href} tabIndex={-1}>{t3}</a>;
    $[10] = href;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleClick || $[14] !== result || $[15] !== t4) {
    t5 = <Autocomplete.Item className="header-search__cell" onClick={handleClick} value={result}>{t4}</Autocomplete.Item>;
    $[13] = handleClick;
    $[14] = result;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}